import { Currency } from '@/types/graphql';
import getOnboardingConfig from '@/components/partials/jobs/onboarding/constants/getOnboardingConfig';
import type { GetOTEValidationRulePayload, JobsOnboardingStep } from '@/components/partials/jobs/onboarding/types';

export const getOnboardingV2Steps = (): JobsOnboardingStep[] => {
  return [...getOnboardingConfig()];
};

export const getCurrencyByCountryCode = (countryCode?: string | null) => {
  return countryCode === 'IN' ? Currency.Inr : Currency.Usd;
};

export const getOteIsLowerThanBaseSalaryValidation =
  ({ form, required }: GetOTEValidationRulePayload) =>
  (value: number) => {
    if (!required) return true;
    if (isNaN(value)) return true;
    if (!form.baseSalary) return true;

    return Boolean(value > form.baseSalary);
  };